/**
 * The colours of a surah's cover art (SurahArtwork) and of the full-screen
 * player behind it: deep greens, teals and a bronze that all carry the gold.
 * Picked by surah number, so each surah keeps the same face everywhere.
 */
const GRADIENTS = [
  ['#1c4848', '#0b2626'],
  ['#1f5a52', '#0b2a27'],
  ['#21465c', '#0c1f2c'],
  ['#2d4f3c', '#10261b'],
  ['#2b3d55', '#111a29'],
  ['#4b3b23', '#1e160a'],
];

export const artworkGradient = (surah) => GRADIENTS[(Math.max(1, surah) - 1) % GRADIENTS.length];
